/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salary_Upgrade_CtaInputs */

const en_salary_upgrade_cta = /** @type {(inputs: Salary_Upgrade_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View Plans`)
};

const de_salary_upgrade_cta = /** @type {(inputs: Salary_Upgrade_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pläne ansehen`)
};

const fr_salary_upgrade_cta = /** @type {(inputs: Salary_Upgrade_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voir les plans`)
};

const es_salary_upgrade_cta = /** @type {(inputs: Salary_Upgrade_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver planes`)
};

const it_salary_upgrade_cta = /** @type {(inputs: Salary_Upgrade_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vedi piani`)
};

const nl_salary_upgrade_cta = /** @type {(inputs: Salary_Upgrade_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bekijk plannen`)
};

const pl_salary_upgrade_cta = /** @type {(inputs: Salary_Upgrade_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zobacz plany`)
};

const fi_salary_upgrade_cta = /** @type {(inputs: Salary_Upgrade_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Näytä suunnitelmat`)
};

const da_salary_upgrade_cta = /** @type {(inputs: Salary_Upgrade_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se planer`)
};

const sv_salary_upgrade_cta = /** @type {(inputs: Salary_Upgrade_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visa planer`)
};

/**
* | output |
* | --- |
* | "View Plans" |
*
* @param {Salary_Upgrade_CtaInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const salary_upgrade_cta = /** @type {((inputs?: Salary_Upgrade_CtaInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salary_Upgrade_CtaInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_salary_upgrade_cta(inputs)
	if (locale === "fr") return fr_salary_upgrade_cta(inputs)
	if (locale === "es") return es_salary_upgrade_cta(inputs)
	if (locale === "it") return it_salary_upgrade_cta(inputs)
	if (locale === "nl") return nl_salary_upgrade_cta(inputs)
	if (locale === "pl") return pl_salary_upgrade_cta(inputs)
	if (locale === "fi") return fi_salary_upgrade_cta(inputs)
	if (locale === "da") return da_salary_upgrade_cta(inputs)
	if (locale === "sv") return sv_salary_upgrade_cta(inputs)
	return en_salary_upgrade_cta(inputs)
});